(function () {
    angular.module('emarket.store.static')
    .controller('StoreStaticController', ['$scope', '$rootScope', '$state', 'profile', function ($scope, $rootScope, $state, profile) {
        var vm = this;
        vm.store = profile;
        var getContent = function () {
            var content;
            var title;
            if ($state.current.name === 'store.static.about') {
                content = profile.store.about;
                title = 'Sobre Tu Mamasita Store';
            } else {
                content = profile.store.policy;
                title = 'Politica de compra';
            }
            return {
                content: content,
                title: title
            };
        };
        var staticContent = getContent();
        vm.content = staticContent.content;
        vm.title = staticContent.title;

        var ev = $rootScope.$on('$stateChangeSuccess', function () {
            var staticContent = getContent();
            vm.content = staticContent.content;
            vm.title = staticContent.title;
        });
        $scope.$on('$destroy', function () {
            ev();
        });
    }]);
}());
